import { FunctionalComponent, h } from '@stencil/core'
import { JSXBase } from '@stencil/core/internal'

import { stringToRegex } from '../utils/text'

export const Mark: FunctionalComponent<{ query: RegExp | string } & JSXBase.IntrinsicElements['mark']> = (
  { query, ...markAttrs },
  [text]
) => {
  // Do not allow matching for strings that are too short or too long
  if (!(query instanceof RegExp) && (!query || query.length < 3 || query.length > 100)) {
    return [text]
  }

  const regex: RegExp =
    query instanceof RegExp
      ? query
      : // eslint-disable-next-line
        stringToRegex(query, 'gi')

  const string = text as unknown as string
  return string.split(regex).map((str) => (regex.test(str) ? <mark {...markAttrs}>{str}</mark> : str)) as any
}
